export { default as saveMailboxJunkEmailConfiguration } from './actions/saveMailboxJunkEmailConfiguration';

export { default as getMailboxJunkEmailConfiguration } from './utils/getMailboxJunkEmailConfiguration';

export {
    getMailboxJunkEmailListByScenarioId,
    getMailboxJunkEmailIsTrustedListsOnly,
    getMailboxJunkEmailIsContactsTrusted,
    getStoredMailboxJunkEmailConfiguration,
} from './utils/getMailboxJunkEmailUtils';

export { default as initMailboxJunkEmailConfiguration } from './actions/initMailboxJunkEmailConfiguration';

export { default as SpamScenarioId } from './store/schema/SpamScenarioId';
